/**
 * HL-12029 WL summary page "edit answers". The A/B test closed (HL-12595) and arm B — pencil
 * icons + health profile modal — is the only page now. What is left is the `funnel` property
 * the summary_* events carry to tell the WL catalogs apart.
 */

import { getWlFunnelVariant } from "./funnelMentionRedirects";

export type WlSummaryFunnel = "wl2" | "wl3";

/** `funnel` event property: the V3 questionnaire (DE weight_loss_3, UK weight_loss_2) → wl3, everything else in the WL flow → wl2. */
export const getWlSummaryFunnel = (mention: unknown, country?: string): WlSummaryFunnel => getWlFunnelVariant(mention, country);
